export default "__VITE_ASSET__CxAmKUih__"